export default __webpack_public_path__ + "static/media/plus.f47b769c.svg";